import React from 'react';
import { Cloud, Server, Shield } from 'lucide-react';

const DeploymentSection = () => {
  const deploymentOptions = [
    {
      icon: Cloud,
      title: "SaaS or Private Cloud",
      description: "Fully managed service with dedicated cloud infrastructure"
    },
    {
      icon: Server,
      title: "Managed VPC",
      description: "Deployed in your virtual private cloud with full control"
    },
    {
      icon: Shield,
      title: "Full On-Prem / Air-gapped",
      description: "Complete on-premises deployment for maximum security"
    }
  ];

  return (
    <section className="section-spacing bg-[var(--bg-primary)]">
      <div className="light-full-container">
        <div className="light-content-container">
          <div className="space-y-16">
            {/* Header */}
            <div className="text-center space-y-6">
              <h2 className="display-large">Deployment Flexibility</h2>
              <p className="body-large max-w-3xl mx-auto">
                Deploy Anywhere
              </p>
              <p className="body-medium max-w-4xl mx-auto">
                Your infrastructure. Your control.
              </p>
            </div>

            {/* Deployment Options */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {deploymentOptions.map((option, index) => {
                const IconComponent = option.icon;
                return (
                  <div 
                    key={index}
                    className="feature-card text-center space-y-6"
                  >
                    <div className="flex justify-center">
                      <div className="icon-container">
                        <IconComponent className="w-8 h-8" />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <h3 className="heading-3">{option.title}</h3>
                      <p className="body-small">{option.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeploymentSection;